import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import PortalVue from 'portal-vue';
import VueMq from 'vue-mq';
import Alert from '@/helpers/Alert';
import { ProgressPlugin } from '@/helpers/Progress';
import { SignalRPlugin } from '@/helpers/SignalR';
import store from '@/store';

Vue.use(BootstrapVue);
Vue.use(PortalVue);
Vue.use(VueMq, {
    breakpoints: {
        xs: 640, // Telefon (do 639px)
        sm: 960, // Mały tablet (do 959px)
        md: 1366, // Duży tablet (do 1365px)
        lg: 1600, // Laptop (do 1599px)
        xl: Infinity // Desktop
    }
});
Vue.use(Alert, { store });
Vue.use(ProgressPlugin, {
    color: '#E77C00',
    failedColor: 'red',
    thickness: '3px',
    autoFinish: false,
    autoRevert: false,
    inverse: false
});
Vue.use(SignalRPlugin, {
    endpoint: `${process.env.VUE_APP_PUBLIC_URL}/hubs`
});

Vue.component('action-bar', require('@/components/ActionBar.vue').default);
Vue.component('action-button', require('@/components/ActionButton.vue').default);
Vue.component('action-header', require('@/components/ActionHeader.vue').default);

Vue.component('tree', () => import(/* webpackChunkName: "components" */'@/components/Tree.vue'));
Vue.component('sort', () => import(/* webpackChunkName: "components" */'@/components/Sort.vue'));
Vue.component('data-card', () => import(/* webpackChunkName: "components" */'@/components/DataCard.vue'));
Vue.component('data-list', () => import(/* webpackChunkName: "components" */'@/components/DataList.vue'));
Vue.component('data-table', () => import(/* webpackChunkName: "components" */'@/components/DataTable.vue'));
Vue.component('data-table-row', () => import(/* webpackChunkName: "components" */'@/components/DataTableRow.vue'));
Vue.component('data-table-cell', () => import(/* webpackChunkName: "components" */'@/components/DataTableCell.vue'));
Vue.component('data-size', () => import(/* webpackChunkName: "components" */'@/components/DataSize.vue'));
Vue.component('data-sorting', () => import(/* webpackChunkName: "components" */'@/components/DataSorting.vue'));
Vue.component('pagination', () => import(/* webpackChunkName: "components" */'@/components/Pagination.vue'));
Vue.component('confirmation', () => import(/* webpackChunkName: "components" */'@/components/Confirmation.vue'));
Vue.component('responsive', () => import(/* webpackChunkName: "components" */'@/components/Responsive.vue'));
Vue.component('filepicker', () => import(/* webpackChunkName: "components" */'@/components/FilePicker.vue'));
Vue.component('fileupload', () => import(/* webpackChunkName: "components" */'@/components/FileUpload.vue'));
Vue.component('datetimepicker', () => import(/* webpackChunkName: "components" */'@/components/DateTimePicker.vue'));
Vue.component('multiselect', () => import(/* webpackChunkName: "components" */'vue-multiselect'));
Vue.component('placeholder', () => import(/* webpackChunkName: "components" */'@/components/placeholders/Placeholder.vue'));
Vue.component('placeholder-form', () => import(/* webpackChunkName: "components" */'@/components/placeholders/Form.vue'));
Vue.component('placeholder-grid', () => import(/* webpackChunkName: "components" */'@/components/placeholders/Grid.vue'));
Vue.component('filemanager', () => import(/* webpackChunkName: "filemanager" */'@/components/filemanager/Component.vue'));
Vue.component('editor', () => import(/* webpackChunkName: "editor" */'@/components/Editor.vue'));

// AgGrid
// import "ag-grid-enterprise";
// import {LicenseManager} from "ag-grid-enterprise";

// LicenseManager.setLicenseKey("your license key");

// import(/* webpackChunkName: "grid" */'ag-grid-vue').then(({AgGridVue}: any) =>
// {
//     Vue.component('ag-grid-vue', AgGridVue);
// });

// Module settings
const requireModuleComponent = require.context('@/views/modules', true, /[A-Z]\w+Settings\.(vue|js)$/);

requireModuleComponent.keys().forEach(fileName =>
{
    const component = requireModuleComponent(fileName);
    const name = component.default.extendOptions.name || component.default.name;
    (store.state as any).components.modules.push(name);
    Vue.component(name, component.default);
});

// Widget settings
const requireWidgetComponent = require.context('@/views/widgets', true, /[A-Z]\w+Settings\.(vue|js)$/);

requireWidgetComponent.keys().forEach(fileName =>
{
    const component = requireWidgetComponent(fileName);
    const name = component.default.extendOptions.name || component.default.name;
    (store.state as any).components.widgets.push(name);
    Vue.component(name, component.default);
});